import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'doc-form-field-error',
  templateUrl: 'field-error.component.html',
  styleUrls: ['field-error.component.scss']
})

export class DocFieldErrorComponent implements OnInit {

  @Input() parentForm: UntypedFormGroup;
  @Input() controlName: string;

  get control() {
    if (!this.controlName) {
      return null;
    }
    if (this.parentForm) {
      return this.parentForm.get(this.controlName) as UntypedFormControl
    } else {
      return null
    }
  }

  constructor(
  ) { }

  ngOnInit() { }

  getErrorMessage() {

    if (this.controlName.includes('verify_password') && this.control.parent.errors) {
      if (this.control.parent.errors.hasOwnProperty('verifyPasswordError')) {
        return "Password Mismtach ";
      }
    }

    if (this.controlName.includes('verify_email') && this.control.parent.errors) {
      if (this.control.parent.errors.hasOwnProperty('verifyEmailError')) {
        return "Email Mismatch";
      }
    }

    if (!this.control.errors) {
      return ''
    }

    if (this.control.errors.hasOwnProperty('required')) {
      return 'required field';
    }

    else if (this.control.errors.hasOwnProperty('lanrError')) {
      return "Invalid Lanr";
    }
    else if (this.control.errors.hasOwnProperty('lastnameError')) {
      return "Invalid Last Name";
    }
    else if (this.control.errors.hasOwnProperty('passwordError')) {
      return "Invalid Password";
    }
    else if (this.control.errors.hasOwnProperty('phoneError')) {
      return "Invalid Phone";
    }
    else if (this.control.errors.hasOwnProperty('postalcodeError')) {
      return "Invalid Postal Code";
    }
    else if (this.control.errors.hasOwnProperty('stateError')) {
      return "Invalid State";
    }
    else if (this.control.errors.hasOwnProperty('titleError')) {
      return "Invalid Title";
    }
    else if (this.control.errors.hasOwnProperty('urlError')) {
      return "Invalid Url";
    }
    else if (this.control.errors.hasOwnProperty('uuidError')) {
      return "Invalid Uuid";
    }else if (this.control.errors.hasOwnProperty('otpError')) {
      return "Invalid Otp";
    }

     else {
      return ''
    }
  }
}
